import { type ButtonProps, Button, Menu, Tooltip } from "@mantine/core";
import React from "react";

interface ExcelExportDropdownProps {
  excelExportVisibleColumns: () => void;
  exportExcelAllColumns: () => void;
  buttonVariant?: ButtonProps["variant"];
  buttonColor?: ButtonProps["color"];
}

const ExcelExportDropdown: React.FC<ExcelExportDropdownProps> = ({
  excelExportVisibleColumns,
  exportExcelAllColumns,
  buttonVariant = "light",
  buttonColor = "mc-primary",
}) => {
  return (
    <Menu shadow="md" width={240} position="bottom-end" withinPortal>
      <Menu.Target>
        <Tooltip label="Eksporter til Excel" withArrow offset={2} openDelay={200}>
          <Button variant={buttonVariant} color={buttonColor} px="sm" size="sm" aria-label="Eksporter til Excel">
            <i className="fa fa-file-excel-o fa-fw" />
          </Button>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => exportExcelAllColumns()} leftSection={<i className="fa fa-table fa-fw" />}>
          Eksporter alle kolonner
        </Menu.Item>
        <Menu.Item onClick={() => excelExportVisibleColumns()} leftSection={<i className="fa fa-columns fa-fw" />}>
          Eksporter utvalgte kolonner
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default ExcelExportDropdown;
